import { createFileRoute } from "@tanstack/react-router";
import { ResearchLanding } from "@/components/ResearchLanding";

export const Route = createFileRoute("/_auth/_agents/chats/")({
  component: ResearchLanding,
});
